import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { FnSwitchComponent } from './fn-switch.component';

export * from './fn-switch.component';
/** 
 * Exports the required FnSwitchComponent to create switch button
 * making them available for import by NgModules that import this module.
 */
@NgModule({
  declarations: [FnSwitchComponent],
  imports: [CommonModule, FormsModule],
  exports: [FnSwitchComponent],

})
export class FnSwitchModule {

}
